var RevistaSearch = RevistaSearch || {};

// ============================================================================
// CONFIGURAÇÕES E CONSTANTES
// ============================================================================

RevistaSearch.CONFIG = {
  API: {
    BASE_URL: '/revista',
    SEARCH_ENDPOINT: '/search',
    TIMEOUT_MS: 10000,
  },
  PAGINATION: {
    DEFAULT_PAGE: 0,
    DEFAULT_SIZE: 10,
    MIN_SKELETON_ITEMS: 6,
    MAX_SKELETON_ITEMS: 10,
  },
  SEARCH: {
    ORDER: {
      MOST_RELEVANT: 'MOST_RELEVANT',
      MOST_RECENT: 'MOST_RECENT',
    },
    TYPE: {
      ANY: 'ANY',
      ALL: 'ALL',
      PHRASE: 'PHRASE',
    },
  },
  ERROR_TYPE: {
    VALIDATION: 'validation',
    TIMEOUT: 'timeout',
    CANCELLED: 'cancelled',
    NETWORK: 'network',
    HTTP: 'http',
    UNKNOWN: 'unknown',
  },
  CANCEL_REASON: {
    NEW_SEARCH: 'new-search',
    TIMEOUT: 'timeout',
  },
  URL_PARAM: {
    QUERY: 'query',
    MATCH: 'match',
    SORT: 'sort',
    FROM: 'from',
    TO: 'to',
    TYPES: 'types',
    PAGE: 'page',
    SIZE: 'size',
  },
  SELECTORS: {
    form: '#form-busca',
    queryInput: '#search-query',
    matchRadios: 'input[name="match"]',
    sortSelect: '#search-sort',
    dateFromInput: 'input[name="date-from"]',
    dateToInput: 'input[name="date-to"]',
    typeCheckboxes: 'input[name="content_type"]',
    resultsHeader: '.search-results__header',
    resultsContainer: '#search-results',
    resultsInfo: '#search-results-info',
    resultsList: '#search-results-list',
    paginationRoot: '.pagination[data-total-pages]',
  },
  ASSETS: {
    pdfIcon: '/lumis-theme/br/gov/pr/tce/magazine/theme/tce-pr-revista/assets/images/icons/icon-pdf.svg',
    emptySearchIcon: '/lumis-theme/br/gov/pr/tce/magazine/theme/tce-pr-revista/assets/images/icons/icon-empty-search.svg',
    errorIcon: '/lumis-theme/br/gov/pr/tce/magazine/theme/tce-pr-revista/assets/images/icons/icon_info-circle_error.svg',
    warningBlueIcon: '/lumis-theme/br/gov/pr/tce/magazine/theme/tce-pr-revista/assets/images/icons/icon_info-circle_warning-blule.svg',
  },
};

RevistaSearch.CONTENT_TYPES = {
  EDITORIAL: {
    api: 'EDITORIAL',
    form: 'editorial',
    display: 'Editorial',
    showBadge: false,
    showAuthor: false,
    defaultTitle: 'EDITORIAL',
  },
  ARTIGO: {
    api: 'ARTIGO',
    form: 'artigos',
    display: 'Artigo',
    showBadge: true,
    showAuthor: true,
    defaultTitle: null,
  },
  ACORDAO: {
    api: 'ACORDAO',
    form: 'acordaos',
    display: 'Acórdão',
    showBadge: true,
    showAuthor: false,
    defaultTitle: null,
  },
  LEGISLACAO: {
    api: 'LEGISLACAO',
    form: 'legislacao',
    display: 'Legislação',
    showBadge: false,
    showAuthor: false,
    defaultTitle: 'LEGISLAÇÃO',
  },
  LINKS: {
    api: 'LINKS',
    form: 'links',
    display: 'Links',
    showBadge: false,
    showAuthor: false,
    defaultTitle: 'LINKS DE INTERESSE',
  },
};

RevistaSearch.ALL_TYPES_VALUE = 'EDITORIAL,ARTIGO,ACORDAO,LEGISLACAO,LINKS';
